import axios from "axios";

export const BASE_URL = (() => {
  if (process.env.NODE_ENV !== "production") {
    return "http://localhost:8000";
  }
  const fromEnv = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, "");
  if (fromEnv) {
    return fromEnv;
  }
  const renderHost = process.env.REACT_APP_RENDER_API_SERVICE;
  if (renderHost) {
    return `https://${renderHost}.onrender.com`;
  }
  return "http://localhost:8000";
})();
const allowed401s = [
  "/api/token/",
  "/api/token/refresh/",
  "/api/v1/auth/register/",
  "/api/v1/auth/google/start/",
  "/api/v1/auth/google/callback/",
  "/api/v1/auth/oauth/exchange/",
];


// set interceptors to pass auth token if we have it in the local storage
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// if response is 401 and it's not a retry, refresh access token
axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  const originalRequest = error.config || {};
  const requestUrl = (originalRequest.url || "").replace(BASE_URL, "");
  if (
    error.response &&
    error.response.status === 401 &&
    !originalRequest._retry &&
    !allowed401s.includes(requestUrl)
  ) {
    originalRequest._retry = true;
    return postRequest(
      "/api/token/refresh/",
      { refresh: localStorage.getItem("refreshToken") },
      (response) => {
        const accessToken = response.data.access;
        localStorage.setItem("accessToken", accessToken);
        if (response.data.refresh) {
          localStorage.setItem("refreshToken", response.data.refresh);
        }
        return axios(originalRequest);
      },
      () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location = "/login/";
      }
    );
  }

  return Promise.reject(error);
});


const getRequest = (url, successCallback, errorCallback) => {
  return axios
    .get(BASE_URL + url)
    .then((response) => {
      if (successCallback) {
        return successCallback(response);
      }
      return response;
    })
    .catch((error) => {
      // take user to login if they just made an invalid 401 request
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)) {
        window.location = `/login/?next=${window.location.href}`;
      } else if (errorCallback) {
        return errorCallback(error);
      }
      return Promise.reject(error);
    });
};

const postRequest = (url, data, successCallback, errorCallback) => {
  return axios
    .post(BASE_URL + url, data)
    .then((response) => {
      if (successCallback) {
        return successCallback(response);
      }
      return response;
    })
    .catch((error) => {
      // take user to login if they just made an invalid 401 request
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)) {
        window.location = `/login/?next=${window.location.href}`;
      } else if (errorCallback) {
        return errorCallback(error);
      }
      return Promise.reject(error);
    });
};

const patchRequest = (url, data, successCallback, errorCallback) => {
  return axios
    .patch(BASE_URL + url, data)
    .then((response) => {
      if (successCallback) {
        return successCallback(response);
      }
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)) {
        window.location = `/login/?next=${window.location.href}`;
      } else if (errorCallback) {
        return errorCallback(error);
      }
      return Promise.reject(error);
    });
};

const deleteRequest = (url, successCallback, errorCallback) => {
  return axios
    .delete(BASE_URL + url)
    .then((response) => {
      if (successCallback) {
        return successCallback(response);
      }
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)) {
        window.location = `/login/?next=${window.location.href}`;
      } else if (errorCallback) {
        return errorCallback(error);
      }
      return Promise.reject(error);
    });
};

export { getRequest, postRequest, patchRequest, deleteRequest };